import { AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { TAppointment } from 'ui-model';
import axiosClient from '@lib/utils/axiosClient';

const requestKey = 'lumabot-appointment-cancellation';

export type UseMutateAppointmentCancellationResult = UseMutationResult<
  AxiosResponse<TAppointment> | void,
  unknown,
  string,
  unknown
>;

const useMutateAppointmentCancellation = (): UseMutateAppointmentCancellationResult => {
  const request = (id: string) => axiosClient.put<TAppointment>(`/appointments/${id}/cancel`);

  return useMutation(requestKey, request);
};

export default useMutateAppointmentCancellation;
